import { useEffect } from 'react';
import { URLS } from '@livingsecurity/shared';

/**
 * The Support Garden used to be embedded here in an iframe, but www.livingsecurity.com
 * blocks framing, so admins who landed on /support only ever saw the browser's
 * "refused to connect" error page.
 *
 * The App Switcher now links straight out to the Support Garden. This route is kept so
 * that existing bookmarks and shared /support links still end up in the right place.
 */
const SupportGarden = () => {
  useEffect(() => {
    window.location.replace(URLS.supportDesk);
  }, []);

  return null;
};

export default SupportGarden;
